import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'

export function useWatchersPropertyTypeStrategy() {

  const getRestrictedEditReason = (): RestrictedEditReasonType | null => {
    return null
  }

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    const value = groupItem?.value ?? null
    const userId = Array.isArray(value) ? value[0] ?? null : value
    if(userId === null) {
      return {
        type: FilterItemType.Property,
        id: group,
        operator: {
          type: FilterPropertyOperator.Empty,
        },
        subProperty: null,
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: null,
        },
        isDisabled: false,
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.ArrayIncludes,
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: [userId],
      },
      isDisabled: false,
    }
  }

  return {
    getRestrictedEditReason,
    getGroupFilter,
  }
}
